import React from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pathWithPreservedParams } from '../../routing/navigation.js';
import './Sidebar.css';

/**
 * Sidebar navigation component
 * @returns {JSX.Element} Sidebar component
 */
const Sidebar = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const navigationItems = [
    {
      id: 'overview',
      to: '/overview',
      label: t('sidebar.overview'),
      icon: '🧭',
      iconType: 'emoji',
      description: t('sidebar.overviewDescription'),
      end: true
    },
    {
      id: 'projects',
      to: '/projects',
      label: t('sidebar.projects'),
      icon: '📁',
      iconType: 'emoji',
      description: t('sidebar.projectsDescription'),
      end: false
    },
    {
      id: 'dashboards',
      to: '/dashboards',
      label: t('sidebar.dashboards'),
      icon: '/dashboard_icon.svg',
      iconType: 'svg',
      description: t('sidebar.dashboardsDescription'),
      end: true
    }
  ];

  return (
    <aside className="sidebar">
      <nav className="sidebar-nav">
        <ul className="nav-list">
          {navigationItems.map((item) => (
            <li key={item.id} className="nav-item">
              <NavLink
                to={pathWithPreservedParams(item.to, searchParams)}
                end={item.end}
                className={({ isActive }) => `nav-button ${isActive ? 'active' : ''}`}
                title={item.description}
              >
                <span className="nav-icon">
                  {item.iconType === 'svg' ? (
                    <img src={item.icon} alt={item.label} className="nav-icon-svg" />
                  ) : item.iconType === 'component' ? (
                    <item.icon size={24} className="nav-icon-component" />
                  ) : (
                    item.icon
                  )}
                </span>
                <span className="nav-label">{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
